import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import { inject, Injectable, Optional, SkipSelf } from '@angular/core';
import LocaleHelper from 'helper/localeHelper';
import { PrimeNG } from 'primeng/config';
import { all as primeNgLocales } from 'primelocale';

/*
 * https://github.com/armanozak/angular-dynamic-locale
 * https://stackblitz.com/edit/angular-dynamic-locale
 */
@Injectable({
	providedIn: 'root',
})
export class LocaleService {
	private _currentLocale;

	get currentLocale(): string {
		return this._currentLocale;
	}

	private readonly primeNg = inject(PrimeNG);

	constructor(
		@Optional()
		@SkipSelf()
		otherInstance: LocaleService,
	) {
		if (otherInstance) {
			throw new Error('LocaleService should have only one instance.');
		}
		document.addEventListener('afterReinitLocaleHelper', () => {
			this.setLocale(LocaleHelper.getFormat());
		});
	}

	private registerLocaleData() {
		const locale = {
			'cs-CZ': localeCs,
			'de-DE': localeDe,
			'en-GB': localeEnGb,
			'es-ES': localeEs,
			'fr-FR': localeFr,
			'hu-HU': localeHu,
			'it-IT': localeIt,
			'nl-NL': localeNl,
			'pl-PL': localePl,
		}[this._currentLocale] || localeDe;
		registerLocaleData(locale);
		const primeNgLocale = primeNgLocales[this.currentLocale] ?? primeNgLocales[this.currentLocale.substring(0, 2)] ?? primeNgLocales['de'];
		this.primeNg.setTranslation(primeNgLocale);
	}

	setLocale(localeId: string) {
		this._currentLocale = localeId.replace('_', '-');
		this.registerLocaleData();
	}
}
